import { styled } from '@linaria/react';

const ActionButton = styled.button`
  width: 2rem;
  height: 2rem;
  display: flex;
  justify-content: center;
  align-items: center;
  color: inherit;
  opacity: 1;

  svg {
    display: block;
  }

  &:focus-visible {
    outline-color: var(--color-primary);
    outline-offset: -1px;
  }
`;

export default ActionButton;
